export function isPointerEvent(event: MouseEvent): event is PointerEvent {
    return 'pointerId' in event && 'pointerType' in event;
}

export function isTouchEvent(event: MouseEvent): boolean {
    return isPointerEvent(event) && event.pointerType === 'touch';
}
